import React from "react";
import { Link } from "react-router-dom";
// import {XLg,ChevronLeft,ArrowRight} from 'react-bootstrap-icons';
function AdvancedMenuItems({
  advancedMenuLogo,
  handleClose,
  advancedMenuTitle,
  path,
}) {
  // const closeCollapse = () => {
  //     props.setCollapsed(true)

  // }
  return (
    <div className="px-3 py-2 ">
      <span className="bg-light rounded-2 d-inline-block px-2 py-1">
        {" "}
        {advancedMenuLogo}
      </span>
      <Link className="mx-3 " onClick={handleClose} to={path}>
        {advancedMenuTitle}
      </Link>
      {/* <div className="px-3 py-2">
        {props.header ? (
          <div size={10} onClick={props.handleClose} />
        ) : (
          <Link
            onClick={!props.header && props.handleClose}
            to={props.path}
          ></Link>
        )}
      </div> */}
    </div>
  );
}
//
export default AdvancedMenuItems;
